import { render, staticRenderFns } from "./CreateOneOffCampaign.vue?vue&type=template&id=12a4b66c&scoped=true&"
import script from "./CreateOneOffCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateOneOffCampaign.vue?vue&type=script&lang=js&"
import style0 from "./CreateOneOffCampaign.vue?vue&type=style&index=0&id=12a4b66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4b66c",
  null
  
)

export default component.exports